import { AsyncState, loadingAsyncState, Updater } from 'widgets-for-react'
import { PageResult } from '../cmsPage/sharepointPageApi/types/pageData'
import { fetchFilters, fetchOpleidingen, fetchOpleidingenBlocks } from './opleidingenOverviewApi'
import { ImageBase, ImageOptions } from '../../utils/images'
import { BlocksState } from '../cmsPage/blocks/blocksState'
import { DataLayer } from '../../utils/datalayer'

export const PAGE_SIZE = 10

export type OverviewCourseItem = {
  url: string
  title: string
  label: string
  newprice: string
  oldprice: string
  duration: string
  image?: ImageBase & ImageOptions
}

export type OpleidingenOverviewPageState = {
  filters: AsyncState<OpleidingFilter[]>
  opleidingen: AsyncState<PageResult<OverviewCourseItem>>
  blocks: AsyncState<BlocksState>
  openMobileSidebar: boolean
  page: number
  query?: string
}

export type OpleidingFilter = {
  name: string
  availableCourses: number
  isSelected: boolean
}

export const initialOpleidingenOverviewState = (
  filtersUrlParam: string,
  queryUrlParam: string,
  pageUrlParam: string
): OpleidingenOverviewPageState => {
  return {
    filters: loadingAsyncState(() => fetchFilters(filtersUrlParam)),
    opleidingen: loadingAsyncState(
      () => fetchOpleidingen(parseInt(pageUrlParam), PAGE_SIZE, filtersUrlParam, queryUrlParam),
    ),
    blocks: loadingAsyncState(() => fetchOpleidingenBlocks()),
    openMobileSidebar: false,
    query: queryUrlParam,
    page: parseInt(pageUrlParam),
  }
}

export const opleidingenOverviewStateUpdaters = {
  updateFilters:
    (updater: Updater<AsyncState<OpleidingFilter[]>>) =>
      (state: OpleidingenOverviewPageState): OpleidingenOverviewPageState => ({
        ...state,
        filters: updater(state.filters),
      }),
  updateOpleidingen:
    (updater: Updater<AsyncState<PageResult<OverviewCourseItem>>>) =>
      (state: OpleidingenOverviewPageState): OpleidingenOverviewPageState => ({
        ...state,
        opleidingen: updater(state.opleidingen),
      }),
  updateOpleidingenBlocks:
    (updater: Updater<AsyncState<BlocksState>>) =>
      (state: OpleidingenOverviewPageState): OpleidingenOverviewPageState => ({
        ...state,
        blocks: updater(state.blocks),
      }),
  updateIndividualFilter:
    (filterName: string, isSelected: boolean) =>
      (oldState: OpleidingenOverviewPageState): OpleidingenOverviewPageState => {
        if (oldState.filters.kind !== 'loaded') return oldState
        const newState = {
          ...oldState,
          filters: {
            ...oldState.filters,
            value: oldState.filters.value.map((filter) =>
              filter.name === filterName ? { ...filter, isSelected } : filter
            ),
          },
        }
        // Track filter event if the filter is selected
        const selectedFilter = newState.filters.value.find((f) => f.name === filterName)
        if (selectedFilter && selectedFilter.isSelected)
        {
          DataLayer.CourseOverviewFilterEvent(
            filterName,
            selectedFilter?.name || "",
            selectedFilter?.availableCourses || 0,
          );
        }
        return newState;
      },
  updateQuery:
    (newQuery: string) =>
      (oldState: OpleidingenOverviewPageState): OpleidingenOverviewPageState => {
        const newState = { ...oldState, query: newQuery }
        return newState
      },
  updateOpenMobileSidebar:
    (isOpen: boolean) =>
      (oldState: OpleidingenOverviewPageState): OpleidingenOverviewPageState => {
        DataLayer.CourseOverviewToggleMobileMenu(isOpen ? 'open' : 'close');
        return ({
        ...oldState,
        openMobileSidebar: isOpen,
      })},
}
